import {ArtfactKind, DbEntity, FieldEntity, FieldModelXrefEntity, FieldTypeKind, Metadata, ModelDbXrefEntity} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, Observer, of} from 'rxjs';
import fs from 'fs';
import {Client, types} from 'cassandra-driver';
import {concatMap, filter, map, toArray} from 'rxjs/operators';
import oracledb from 'oracledb';

@HookClass('database.oracle', '23bac333-af71-4444-8473-0530cabd9629')
export class DatabaseOracleHook extends BaseHook {

    private static connections = new Map<string, Client>();
    private static connectionByModel = new Map<string, string>();

    @Hook('bb2d56bd-ce0a-42bc-8966-8dfd40971d12')
    public authenticate(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return of(inputArtifact)
            .pipe(concatMap(() => {
                if (!inputArtifact.object.dbId)
                    throw new Error('Invalid Database ID.');

                if (DatabaseOracleHook.connections.has(inputArtifact.object.dbId))
                    return of(DatabaseOracleHook.connections.get(inputArtifact.object.dbId));

                return this.service('DbService')
                    .pipe(concatMap((service: any) => {
                        return service.findOne(inputArtifact.object.dbId)
                            .pipe(map((dbEntity: DbEntity) => {
                                dbEntity.accessKey$ = service.getAccessKey(dbEntity);
                                return dbEntity;
                            }));
                    }))
                    .pipe(concatMap((dbEntity: DbEntity) => {
                        return dbEntity.accessKey$
                            .pipe(concatMap((access: any) => {

                                oracledb.outFormat = oracledb.OUT_FORMAT_OBJECT;

                                return from(oracledb.getConnection({
                                    user: access.user,
                                    password: access.password,
                                    connectString: access.connectionString
                                }))
                                    .pipe(concatMap((client: any) => {
                                        return this.service('ModelDbXrefService')
                                            .pipe(concatMap((service: any) => {
                                                return service.findModelsByDatabaseId(dbEntity.id);
                                            }))
                                            .pipe(map((models: any[]) => {
                                                client._models = models;
                                                client._modelsMap = new Map<string, any>();
                                                client._dbEntity = dbEntity;

                                                models.forEach((model: any) => {
                                                    DatabaseOracleHook.connectionByModel.set(model.modelId, dbEntity.id);
                                                    client._modelsMap.set(model.modelId, model.model);
                                                });

                                                // todo: store connection with keyspace in hash key name
                                                DatabaseOracleHook.connections.set(dbEntity.id, client);
                                                return client;
                                            }));
                                    }));
                            }));
                    }));
            }))
            .pipe(map(() => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = {success: true};
                return outputArtifact;
            }));
    }

    @Hook('dddc2c43-0d06-4e9e-b520-e81709f90983')
    public query(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return of(inputArtifact)
            .pipe(concatMap(() => {
                if (!inputArtifact.object.dbId)
                    throw new Error('Invalid modelId');

                if (DatabaseOracleHook.connections.has(inputArtifact.object.dbId))
                    return of(DatabaseOracleHook.connections.get(inputArtifact.object.dbId));

                const connectArtifact = new NickProcessArtfact();
                connectArtifact.kind = ArtfactKind.ANY;
                connectArtifact.object = {dbId: inputArtifact.object.dbId};

                return this.authenticate(connectArtifact)
                    .pipe(map(() => DatabaseOracleHook.connections.get(inputArtifact.object.dbId)));
            }))
            .pipe(concatMap((client: any) => {
                return from(client.execute(inputArtifact.object.query, inputArtifact.object.params, inputArtifact.object.options));
            }))
            .pipe(map((result: any) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = result;
                return outputArtifact;
            }));
    }

}
